// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__3vKej","wideContainer":"App_wideContainer__2K67o","logo":"App_logo__fsULj","adminlogo":"App_adminlogo__23YRv"};